import layout from 'layouts/default'
import pagination from 'components/pagination'
import { confirm } from 'components/modals'
import { hasPermits } from 'directives'


const directives = {
  hasPermits
}

const components = {
  layout,
  pagination,
  confirm
}

const methods = {
  loadPage (page) {
    this.loading = true;
    this.$store.dispatch('vendors.getAll', {page, _q: this.searchKey}).then (() => {
      this.loading = false;
    });
  },
  
  search (searchKey) {
    this.searchKey = searchKey;
    this.loadPage(1);
  },

  removeVendor (item) {
    this.$refs.deleteConfirm.confirm('Are you sure?', () => {
      this.vendors_loadings[item.id] = true

      this.$store.dispatch('vendors.removeVendor', item.id).then(() => {
        this.vendors_loadings[item.id] = false

        if (this.$store.state.vendors.errors) {
          this.errors = _.cloneDeep(this.$store.state.vendors.errors.errors);
          if (this.errors.hasOwnProperty('message')) {
            toastr.error(this.errors.message);
          }
        }
      })
    });
  }
}

const computed = {
  vendors () {
    let vendors = _.cloneDeep(this.$store.state.vendors.all);
    _.each(vendors.data, (vendor) => {
      this.vendors_loadings[vendor.id] = false;
    });
    this.vendors_loadings = _.clone(this.vendors_loadings);
    return vendors;
  }
}

export default {
  name: 'all-vendors',
  components,
  methods,
  computed,
  directives,
  data () {
    return {
      loading: true,
      searchKey: null,
      vendors_loadings: {}
    }
  },
  created () {
    this.loadPage (this.$route.query.page || 1);
  }
}
